<div class="modal-header">
  <h4 class="modal-title pull-left">{{'GLOBAL.SITE' | translate}}</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="showModalCancel()" title="{{'GLOBAL.FERMER' | translate}}">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form id="myForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label for="nomSite">{{'GLOBAL.NOM' | translate}}</label>
      <input id="nomSite" type="text" [(ngModel)]="site.nom" (ngModelChange)="siteFieldTouched = true" name="nomSite" class="form-control" placeholder="{{'GLOBAL.NOM' | translate}}" maxlength="256" autocomplete="off" />
      @if (nomInvalide()) {
        <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
      }
    </div>
    @if (estModif) {
      <div class="form-group">
        <label for="selectIsActif">{{'GLOBAL.ACTIF' | translate}}</label>
        <button type="button" name="selectIsActif" btnCheckbox class="toggle-btn" [ngClass]="site.isActif === true ? 'btn-success':'btn-danger'" [(ngModel)]="site.isActif" (ngModelChange)="siteFieldTouched = true">
          {{site.isActif ? ('GLOBAL.OUI' | translate) : ('GLOBAL.NON' | translate)}}
        </button>
      </div>
    }
    <div class="form-group">
      <label for="selectRegion">{{'GLOBAL.REGION' | translate}}</label>
      <ng-select [items]="tabRegions"
        [multiple]="false"
        [closeOnSelect]="true"
        [searchable]="true"
        bindLabel="nom"
        placeholder="{{'GLOBAL.REGION' | translate}}"
        name="selectRegion"
        id="selectRegion"
        [(ngModel)]="regionSelectionnee"
        (ngModelChange)="siteFieldTouched = true"
        class="custom"
        [clearable]="false">
      </ng-select>
      @if (regionInvalide()) {
        <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
      }
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div class="form-group">
          <label for="selectPays">{{'GLOBAL.PAYS' | translate}}</label>
          <ng-select [items]="tabPays"
            [multiple]="false"
            [closeOnSelect]="true"
            [searchable]="true"
            bindLabel="nom"
            placeholder="{{'GLOBAL.PAYS' | translate}}"
            name="selectPays"
            id="selectPays"
            [(ngModel)]="paysSelectionne"
            (ngModelChange)="siteFieldTouched = true"
            [virtualScroll]="true"
            class="custom"
            [clearable]="false">
          </ng-select>
          @if (paysInvalide()) {
            <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
          }
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label for="selectOperationType">{{'GLOBAL.TYPE_OPERATION' | translate}}</label>
          <ng-select [items]="tabOperationTypes"
            [multiple]="false"
            [closeOnSelect]="true"
            [searchable]="true"
            bindLabel="nom"
            bindValue="id"
            placeholder="{{'GLOBAL.TYPE_OPERATION' | translate}}"
            name="selectOperationType"
            id="selectOperationType"
            [(ngModel)]="operationTypeSelectionne"
            (ngModelChange)="siteFieldTouched = true"
            [virtualScroll]="true"
            class="custom"
            [clearable]="false">
          </ng-select>
        </div>
      </div>
    </div>
    @if (!estMiseJour) {
      <div>
        <div class="form-group">
          <label for="selectProfil">{{'MODALE_SITE.PROFIL_DONNEE_ANALYSE' | translate}}</label>
          <ng-select [items]="tabProfils"
            [multiple]="false"
            [closeOnSelect]="true"
            [searchable]="true"
            bindLabel="nom"
            placeholder="{{'MODALE_SITE.PROFIL' | translate}}"
            name="selectProfil"
            id="selectProfil"
            [(ngModel)]="profilSelectionne"
            (ngModelChange)="siteFieldTouched = true"
            [virtualScroll]="true"
            class="custom">
          </ng-select>
        </div>
      </div>
    }
    @if (erreurApi()) {
      <div class="custom-alert custom-alert-sm">{{'GLOBAL.ERREUR_MAJ_API' | translate }}</div>
    }

    <app-epsg-modale [mySite]="site" [isSite]="true"  [newTransformCoordinate]="newTransformCoordinate" (epsgSite)="getEPSGSite($event); siteFieldTouched = true" (epsgCoordinates)="getEPSGCoordinates($event); siteFieldTouched = true" (epsgModif)="isModifEPSG($event); siteFieldTouched = true" (coordX)="getCoordX($event); siteFieldTouched = true" (coordY)="getCoordY($event); siteFieldTouched = true"></app-epsg-modale>

    <div class="row mt-2 align-items-end">
      <div class="col-lg-6">
        <div class="form-group">
          <label for="magVar">{{'GLOBAL.MAG_VAR' | translate}}</label>
          <input id="magVar" type="number" step="0.01" [ngModel]="magVar()" (ngModelChange)="magVar.set($event)" name="magVar" class="form-control" autocomplete="off" />
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label for="meridianConvergence">{{'GLOBAL.MERIDIAN_CONVERGENCE' | translate}}</label>
          <input id="meridianConvergence" type="number" step="0.01" [ngModel]="meridianConvergence()" (ngModelChange)="meridianConvergence.set($event)" name="meridianConvergence" class="form-control" autocomplete="off" />
        </div>
      </div>
    </div>

    @if (erreurCoord()) {
      <div class="custom-alert custom-alert-sm">{{'EPSG.ERREUR_COORD' | translate }}</div>
    }

    <div class="btn-toolbar justify-content-between">
      <div class="btn-group" role="group">
        <button type="submit" class="btn btn-outline-success">{{'GLOBAL.VALIDER' | translate}}</button>
      </div>
      <div class="btn-group" role="group">
        <button type="button" class="btn btn-secondary" (click)="showModalCancel()">{{'GLOBAL.FERMER' | translate}}</button>
      </div>
    </div>
  </form>
</div>

<div bsModal #modalConfirmCancel="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="custom-overlay"></div>
      <div class="modal-body text-center">
        <p>{{'GLOBAL.CONFIRMATION_ANNULATION' | translate}}</p>
        <button type="button" class="btn btn-primary" (click)="annulModif()">{{'GLOBAL.OUI' | translate}}</button>
        <button type="button" class="btn btn-secondary" (click)="modalConfirmCancel?.hide()" style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
      </div>
    </div>
  </div>
</div>
